import React, { useState } from "react";
import "./login.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import useAuth from "../../../hooks/useAuth";
import utilValidations from "../../../common/utils/utilValidations";
import { useTranslateText } from "../../../hooks/userLanguageTranslate";
import { IForgot } from "./IForgot";

const ForgotPassword: React.FC = () => {
  const eventData: any = useSelector((state: RootState) => state.eventData);

  const [formData, setFormData] = useState<IForgot>({ email: "" });
  const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string | null }>({});
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [successMessage, setSuccessMessage] = useState<string[]>([]);

  const { formValidateField } = utilValidations();
  const translateText = useTranslateText;
  const { forgotPassword } = useAuth();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const emailError = formValidateField("email", value);

    setFieldErrors((prev) => ({
      ...prev,
      [name]: emailError ?? null,
    }));

    setErrorMessages([]);
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessages([]);
    setSuccessMessage([]);

    try {
      const response = await forgotPassword(formData.email);
      setSuccessMessage(response);
    } catch (error: any) {
      const errorData = error.response?.data;

      if (errorData?.status === "FAILED") {
        if (Array.isArray(errorData.data)) {
          const messages = errorData.data.map((err: any) =>
            typeof err.message === "string"
              ? err.message
              : err.message?.message ?? "An unknown error occurred."
          );
          setErrorMessages(messages);
        } else {
          setErrorMessages(["An error occurred. Please try again."]);
        }
      } else {
        setErrorMessages([
          typeof error.message === "string" ? error.message : "An unknown error occurred.",
        ]);
      }
    }
  };

  return (
    <div className="forgot-page-wrapper">
      <div className="forgot-container">
        <h2>Forgot Password</h2>

        {/* Error Messages */}
        {fieldErrors.email && <div className="error-text">{fieldErrors.email}</div>}
        {!fieldErrors.email &&
          errorMessages.map((msg, idx) => (
            <div key={idx} className="error-text">
              {msg}
            </div>
          ))}

        {/* Success Message */}
        {successMessage.length > 0 && (
          <div className="success-text">{successMessage}</div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="forgot-form">
          <input
            type="email"
            name="email"
            placeholder={translateText("reset-password-email", "Email")}
            className="form-input"
            onChange={handleChange}
            required
          />

          <input
            type="submit"
            name="submit"
            value={translateText("reset-password-button", "Reset Password")}
            className="submit-btn"
            style={{ backgroundColor: eventData?.register_button_color || "#007bff" }}
          />

          <div className="forgot-links">
            <a href="/login">
              {translateText("back-to-login-link-text", "Back to login")}
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
